import React from 'react';
import { DotLottiePlayer } from '@dotlottie/react-player';
import '@dotlottie/react-player/dist/index.css';

type LottieAnimationProps = {
  playing?: boolean,
}

function LottieAnimation({ }: LottieAnimationProps) {
  const [dotLottie, setDotLottie] = React.useState(null);

  const dotLottieRefCallback = (dotLottie) => {
    setDotLottie(dotLottie);
  };

  return (
    <DotLottiePlayer
      src="/lottie-animation.json"
      className='lottie'
      renderer='canvas'
      rendererSettings={{
        preserveAspectRatio: "xMidYMid slice"
      }}
      loop
      autoplay
    />
  )
};

export default LottieAnimation;
